import axios from 'axios';
import LocalStorage from 'local-storage';

let _CurrentLoggedInUser = null;
let _UserToken = '';
let _Rating = null;
let _AgreementExpiryDate = null;
let _CurrentDataMappingFranchise = null;
let _FranchiseData = null;
let _EnableDataMode = null;
let _EmpTerritory = null;
let _EmpRegion = null;
let _SalesUserTerritory = null;
let _LoginURL = null;
let _PageReload = null;
let _UserLoginDetails = null;
let _HeaderToken = null;
let _PrimaryUser = null;

class AppCache {
    constructor() {
        this.GetCurrentLoggedInUser = () => {

            if (_CurrentLoggedInUser === null)
                _CurrentLoggedInUser = LocalStorage.get("_CurrentLoggedInUser");

            return _CurrentLoggedInUser;

        };

        this.SetCurrentLoggedInUser = (distId, distributorName, distributorCode, wwid, userId, userType, userRoleName, userName, userFirstName, userLastName, profileImage, userLoggedInDate, token, isHnCActive, impersonAccess, sessionId) => {
            const CurrentLoggedInUser = {
                DistId: distId,
                DistributorName: distributorName,
                DistributorCode: distributorCode,
                WWID: wwid,
                UserId: userId,
                userType,
                UserRoleName: userRoleName,
                UserName: userName,
                UserFirstName: userFirstName,
                UserLastName: userLastName,
                ProfileImage: profileImage,
                UserLoggedInDate: userLoggedInDate,
                Token: token,
                IsHnCActive: isHnCActive,
                ImpersonAccess: impersonAccess,
                SessionId: sessionId
            }

            _CurrentLoggedInUser = CurrentLoggedInUser;

            LocalStorage.set("_CurrentLoggedInUser", _CurrentLoggedInUser);
            _UserToken = token;
            LocalStorage.set("_UserToken", _UserToken);

            axios.defaults.headers.common.Authorization = `Bearer ${LocalStorage.get("_UserToken")}`;
            axios.defaults.headers.common['Content-Type'] = 'application/json';
        };

        this.UpdateLoggedInUser = (userId, userFirstName, userLastName, profileImage, userName) => {

            _CurrentLoggedInUser = LocalStorage.get("_CurrentLoggedInUser");

            _CurrentLoggedInUser.UserId = userId;
            _CurrentLoggedInUser.UserFirstName = userFirstName;
            _CurrentLoggedInUser.UserLastName = userLastName;
            _CurrentLoggedInUser.UserName = userName;
            _CurrentLoggedInUser.ProfileImage = profileImage;

            LocalStorage.set("_CurrentLoggedInUser", _CurrentLoggedInUser);

        };

        this.GetRating = () => {
            if (_Rating === null)
                _Rating = LocalStorage.get("_Rating");
            return _Rating;
        };

        this.SetRating = (rating) => {
            const Rating = rating;
            _Rating = Rating;
            LocalStorage.set("_Rating", _Rating);
        };

        this.GetAgreementExpiryDate = () => {
            if (_AgreementExpiryDate === null)
                _AgreementExpiryDate = LocalStorage.get("_AgreementExpiryDate");
            return _AgreementExpiryDate;
        };

        this.SetAgreementExpiryDate = (agreementExpiryDate) => {
            const AgreementExpiryDate = agreementExpiryDate;
            _AgreementExpiryDate = AgreementExpiryDate;
            LocalStorage.set("_AgreementExpiryDate", _AgreementExpiryDate);
        };

        this.GetCurrentDataMappingFranchise = () => _CurrentDataMappingFranchise;

        this.SetCurrentDataMappingFranchise = (franchise) => {
            const CurrentDataMappingFranchise = franchise;
            _CurrentDataMappingFranchise = CurrentDataMappingFranchise;
        };

        this.GetFranchiseData = () => _FranchiseData;

        this.SetFranchiseData = (franchiseData) => {
            const FranchiseData = franchiseData;
            _FranchiseData = FranchiseData;
        };

        this.GetEnableDataMode = () => {
            if (_EnableDataMode === null)
                _EnableDataMode = LocalStorage.get("_EnableDataMode");

            return _EnableDataMode;
        };

        this.SetEnableDataMode = (enableOnlineEntry, enableZylem) => {
            const EnableDataMode = {
                EnableOnlineEntry: enableOnlineEntry,
                EnableZylem: enableZylem
            }

            _EnableDataMode = EnableDataMode;
            LocalStorage.set("_EnableDataMode", _EnableDataMode);
        };

        this.GetEmpTerritory = () => {
            if (_EmpTerritory === null)
                _EmpTerritory = LocalStorage.get("_EmpTerritory");

            return _EmpTerritory;
        };

        this.SetEmpTerritory = (franchise, territory, empLevel) => {
            const EmpTerritory = {
                Franchise: franchise,
                Territory: territory,
                EmpLevel: empLevel
            }

            _EmpTerritory = EmpTerritory;
            LocalStorage.set("_EmpTerritory", _EmpTerritory);
        };

        this.GetEmpRegion = () => {
            if (_EmpRegion === null)
                _EmpRegion = LocalStorage.get("_EmpRegion");

            return _EmpRegion;
        };

        this.SetEmpRegion = (franchise, region) => {
            const EmpRegion = {
                Franchise: franchise,
                Region: region
            }

            _EmpRegion = EmpRegion;
            LocalStorage.set("_EmpRegion", _EmpRegion);
        };

        this.GetLoginURL = () => {
            if (_LoginURL === null)
                _LoginURL = LocalStorage.get("_LoginURL");

            return _LoginURL;
        };

        this.SetLoginURL = (loginURL) => {
            const LoginURL = loginURL;
            _LoginURL = LoginURL;

            LocalStorage.set("_LoginURL", _LoginURL);
        };

        this.GetSalesUserTerritory = () => {
            if (_SalesUserTerritory === null)
                _SalesUserTerritory = LocalStorage.get("_SalesUserTerritory");

            return _SalesUserTerritory;
        };

        this.SetSalesUserTerritory = (franchise, territory, empLevel) => {
            const SalesUserTerritory = {
                Franchise: franchise,
                Territory: territory,
                EmpLevel: empLevel
            }

            _SalesUserTerritory = SalesUserTerritory;
            LocalStorage.set("_SalesUserTerritory", _SalesUserTerritory);
        };

        this.GetPageReload = () => {
            if (_PageReload === null)
                _PageReload = LocalStorage.get("_PageReload");

            return _PageReload;
        };

        this.SetPageReload = (pageReload) => {
            const PageReload = pageReload;
            _PageReload = PageReload;

            LocalStorage.set("_PageReload", _PageReload);
        };

        this.GetUserLoginDetails = () => {
            if (_UserLoginDetails === null)
                _UserLoginDetails = LocalStorage.get("_UserLoginDetails");

            return _UserLoginDetails;
        };

        this.SetUserLoginDetails = (franchise, region) => {
            const UserLoginDetails = {
                Franchise: franchise,
                Region: region
            }

            _UserLoginDetails = UserLoginDetails;
            LocalStorage.set("_UserLoginDetails", _UserLoginDetails);
        };

        this.GetHeaderToken = () => {
            if (_HeaderToken === null)
                _HeaderToken = LocalStorage.get("_HeaderToken");

            return _HeaderToken;
        };

        this.SetHeaderToken = (headerToken) => {
            const HeaderToken = headerToken;
            _HeaderToken = HeaderToken;

            LocalStorage.set("_HeaderToken", _HeaderToken);
        };

        this.GetPrimaryUser = () => {
            if (_PrimaryUser === null)
                _PrimaryUser = LocalStorage.get("_PrimaryUser");
            return _PrimaryUser;
        };

        this.SetPrimaryUser = () => {
            const primaryUser = {
                CurrentLoggedInUser: LocalStorage.get("_CurrentLoggedInUser"),
                EmpTerritory: LocalStorage.get("_EmpTerritory"),
                EmpRegion: LocalStorage.get("_EmpRegion"),
                SalesUserTerritory: LocalStorage.get("_SalesUserTerritory"),
                UserLoginDetails: LocalStorage.get("_UserLoginDetails")
            };

            _PrimaryUser = primaryUser;
            LocalStorage.set("_PrimaryUser", _PrimaryUser);
        };

        this.SwitchLoggedInUser = (userData) => {
            if (!window.localStorage.getItem("_PrimaryUser")) {
                this.SetPrimaryUser();
            }

            const storedUser = window.localStorage.getItem("_CurrentLoggedInUser");
            const currentUser = JSON.parse(storedUser);

            const updatedUser = {
                // ...currentUser,
                DistId: userData.distId ?? '',
                DistributorName: userData.distributorName ?? '',
                UserId: userData.userId,
                userType: userData.userType,
                UserRoleName: userData.userRole,
                UserName: userData.userName,
                UserFirstName: userData.userFirstName,
                UserLastName: userData.userLastName,
                IsImpersonating: userData.isImpersonating,
                PrimaryUserId: userData.primaryUserId,
                PrimaryUserName: userData.primaryUserName,
                SessionId: userData.sessionId,
                WWID: userData.wwid,
                DistributorCode: userData.distributorCode,
                IsHnCActive: userData.isHnCActive
            };

            window.localStorage.setItem("_CurrentLoggedInUser", JSON.stringify(updatedUser));

            // Related objects
            this.SetEmpTerritory(userData.franchiseName, userData.territory, userData.empLevel);
            this.SetEmpRegion(userData.franchiseName, userData.region);
            this.SetSalesUserTerritory(userData.franchiseName, userData.territory, userData.empLevel);
            this.SetUserLoginDetails(userData.franchiseName, userData.region);
        };

        this.RevertToPrimaryUser = () => {
            const primaryUser = this.GetPrimaryUser();
            if (!primaryUser) return;

            // Restore everything
            LocalStorage.set("_CurrentLoggedInUser", primaryUser.CurrentLoggedInUser);
            LocalStorage.set("_EmpTerritory", primaryUser.EmpTerritory);
            LocalStorage.set("_EmpRegion", primaryUser.EmpRegion);
            LocalStorage.set("_SalesUserTerritory", primaryUser.SalesUserTerritory);
            LocalStorage.set("_UserLoginDetails", primaryUser.UserLoginDetails);

            // Restore runtime objects
            _CurrentLoggedInUser = primaryUser.CurrentLoggedInUser;
            _EmpTerritory = primaryUser.EmpTerritory;
            _EmpRegion = primaryUser.EmpRegion;
            _SalesUserTerritory = primaryUser.SalesUserTerritory;
            _UserLoginDetails = primaryUser.UserLoginDetails;
        };

        this.ClearStorage = () => {
            LocalStorage.clear();
            _CurrentLoggedInUser = null;
            _UserToken = '';
            _Rating = null;
            _AgreementExpiryDate = null;
            _EnableDataMode = null;
            _EmpTerritory = null;
            _EmpRegion = null;
            _SalesUserTerritory = null;
            _LoginURL = null;
            _PageReload = null;
            _UserLoginDetails = null;
            _HeaderToken = null;
            _PrimaryUser = null;
        };
    }

}

export default new AppCache();